import * as React from 'react';
import * as _ from 'underscore';
import { isNullOrUndefined } from 'util';

import { SpaceContentsRequestAction } from '../../app/actions/spaces/RequestSpaceContentsActions';
import { ExplorerEmptyStateProps } from '../../app/spaces/Components/ExplorerEmpyState';
import { ConnectedExplorer } from '../../app/spaces/Explorer/ConnectedExplorer';
import { ExplorerTestIds } from '../../app/spaces/Explorer/Explorer';
import { ExplorerStyles } from '../../app/spaces/Explorer/ExplorerStyles';
import { SpacesSiteUrls } from '../../app/spaces/SpacesSiteUrls';
import { Messages } from '../../codegen/Localize';
import { BackgroundJobDefinition } from '../../contentDefinitions/BackgroundJobDefinition';
import { WebHttpClientWithErrorToastInstance } from '../../httpClient/WebHttpClientWithErrorToast';
import { SpaceContainerStyles } from '../../style/SpaceContainerStyles';
import { Filter } from '../../ts/helpers/Filter';
import { L10n } from '../../ts/L10n/L10n';
import { ExplorableItemType } from '../../ts/models/ContentType';
import { IBackgroundJobStatistics } from '../../ts/ServerApi/types/IBackgroundJobStatistics';
import { IStringValuedFilterClause } from '../../ts/ServerApi/types/IFilterClause';
import { GetBackgroundJobStatisticsRequest, IGetBackgroundJobStatisticsResult } from '../types/GetBackgroundJobStatisticsRequest';
import { BackgroundJobStyles } from './BackgroundJobStyles';


export interface BackgroundJobsSpaceStateProps {
  readonly urls: SpacesSiteUrls;
  readonly statusFilter?: IStringValuedFilterClause;
}

export interface BackgroundJobsSpaceDispatchProps {
  readonly filterSelected: (selectedItems: ArrayLike<ExplorableItemType>) => void;
  readonly requestSpaceContents: () => SpaceContentsRequestAction;
}

export interface BackgroundJobsSpaceOwnProps {
  readonly siteName: string;
}

export type BackgroundJobsSpaceProps = BackgroundJobsSpaceStateProps & BackgroundJobsSpaceDispatchProps & BackgroundJobsSpaceOwnProps;

interface BackgroundJobsState {
  statistics?: IBackgroundJobStatistics;
}

export class BackgroundJobsSpace extends React.Component<BackgroundJobsSpaceProps, BackgroundJobsState> {
  constructor(props: BackgroundJobsSpaceProps) {
    super(props);
    this.state = {};
  }

  public render() {
    return (
      <div className={SpaceContainerStyles.SpaceContainer}>
        <div className={BackgroundJobStyles.MastheadArea}>
          <div className={ExplorerStyles.SpaceHeaderContent}>
            <div className={ExplorerStyles.SpaceHeaderText}>{Messages.jobsBrowserTitle()}</div>
          </div>
          <div>
            <div className={BackgroundJobStyles.SummaryInfoButtonGroup}>
              {this.state.statistics && <>
                <span style={BackgroundJobStyles.SummaryInfoItem}>
                  {Messages.backgroundJobStatisticsFailed({ COUNT_LOC: L10n.localizedCount(this.state.statistics.failedBackgroundJobs) })}
                </span>
                <span style={BackgroundJobStyles.SummaryInfoItem}>
                  {Messages.backgroundJobStatisticsCompleted({ COUNT_LOC: L10n.localizedCount(this.state.statistics.succeededBackgroundJobs) })}
                </span>
                <span style={BackgroundJobStyles.SummaryInfoItem}>
                  {Messages.backgroundJobStatisticsCancelled({ COUNT_LOC: L10n.localizedCount(this.state.statistics.cancelledBackgroundJobs) })}
                </span>
              </>
              }
            </div>
          </div>
        </div>
        <div className={SpaceContainerStyles.SubplaceArea}>
          <ConnectedExplorer
            supportedDisplayModes={BackgroundJobDefinition.supportedDisplayModes}
            emptyStateProps={this.emptyStateProps()}
            toolbarProps={{
              supportFilterPanel: true,
              toolbarVisibility: 'enabled',
              hideSelection: true,
            }}
          />
        </div>
      </div>
    );
  }

  public componentDidMount() {
    const siteId = BackgroundJobDefinition.defaultFilters('').siteId;
    const filter = isNullOrUndefined(siteId) ? undefined : Filter.and([siteId]);
    WebHttpClientWithErrorToastInstance.sendRequest(new GetBackgroundJobStatisticsRequest({filter}))
      .then((result: IGetBackgroundJobStatisticsResult) => this.setState({
        statistics: result
      }));
    this.props.requestSpaceContents();
  }

  public componentDidUpdate(prevProps: BackgroundJobsSpaceProps) {
    if(!_.isUndefined(this.props.siteName) && prevProps.siteName !== this.props.siteName) {
      this.props.requestSpaceContents();
    }
  }

  private emptyStateProps(): ExplorerEmptyStateProps {
    return {
      dataTestId: ExplorerTestIds.ExplorerNoContent,
      iconUrl: '',
      primaryMessage: Messages.contentEmptyMessage(),
      secondaryMessage: '',
    };
  }

  private onNoContentAction = (): void => {
    // Currently there are no actions that can be performed on background jobs
    // See TFS 872202 for the first expected action to be added
  }
}
